import useAuthRequest from "../request/useAuthRequest";
import bankingRequest from "../../rest/request/account/bankingRequest";
import {idempiereDate} from "../../../../res/dataServices/idempiereDate";

const getCardID = (bank) => {
    return bank.CreditCardType.id
        + "_" + bank.CreditCardNumber
        + "_" + bank.CreditCardExpMM
        + "_" + bank.CreditCardExpYY
        + "_" + bank.A_City
        + "_" + bank.A_Street
        + "_" + bank.A_Zip
        + "_" + bank.A_Name
}

const getSavedCards = (banking) => {

    const isCardExpired = (expireMonth, expireYear) => {
        const currentDate = new Date();
        const expiryDate = new Date(expireYear, expireMonth -1)
        return expiryDate < currentDate;
    }

    const sortedBanks = banking ? banking.map(i => i).sort((thisBank, thatBank) =>
        idempiereDate.getDate(thisBank.Created) > idempiereDate.getDate(thatBank.Created)
    ) : [];

    const saved = {};
    for(const bank of sortedBanks) {
        if(bank.CreditCardNumber && bank.CreditCardNumber.length > 0) {
            if(!isCardExpired(bank.CreditCardExpMM, bank.CreditCardExpYY)) {

                ///============ TURN OFF CREDIT CARD CHARGE ============///
                // bank.CreditCardSurchargeRate = null

                saved[getCardID(bank)] = bank;
            }
        }
    }

    return Object.values(saved);
}

const useBanking = () => {

    const {
        session,
        loading,
        error,
        result,
        sendIt
    } = useAuthRequest();

    if(!loading && !error && !result && session.isSignedIn) {
        const req = bankingRequest();
        sendIt(req.sendIt);
    }

    return {
        loading,
        error,
        getSavedCards,
        banking: result
    }

}

export default useBanking;